import { getContentIndexNameRegex, getIndexNameRegex } from '@app-lib/search-index.lib'

export type SearchBackend = 'product' | 'content' | 'dealer'

export function resolveSearchBackend(indexName: string): SearchBackend {
    if (indexName === 'dealers') {
        return 'dealer'
    }

    if (getContentIndexNameRegex().test(indexName)) {
        return 'content'
    }

    if (getIndexNameRegex().test(indexName)) {
        return 'product'
    }

    throw new Error(`Unknown search index: ${indexName}`)
}
